import { z } from "zod";

/**
 * Wire-format schema for compaction progress SSE events.
 *
 * Example:
 *   event: compaction_progress
 *   data: {"phase": "folding", "pass": 1, "max_passes": 3,
 *          "elapsed_ms": 420, "messages_pending": 12}
 */
export const CompactionProgressEventSchema = z.object({
  phase: z.string(),
  pass: z.number(),
  max_passes: z.number(),
  elapsed_ms: z.number(),
  messages_pending: z.number().optional(),
  messages_in_pass: z.number().optional(),
  messages_folded: z.number().optional(),
  reason: z.string().optional(),
});

export type CompactionProgressEvent = z.infer<
  typeof CompactionProgressEventSchema
>;

/**
 * Wire-format schema for the final compaction SSE event.
 *
 * Example:
 *   event: compaction
 *   data: {"role": "compaction", "uuid": "938d1f19-...", "content": "...",
 *          "covers_through_message_uuid": "5d3973f1-...",
 *          "covered_message_count": 20, "summary_tokens": 2052, "model": "gpt-5.4-mini"}
 */
export const CompactionEventSchema = z.object({
  uuid: z.string(),
  content: z.string(),
  role: z.literal("compaction"),
  covers_through_message_uuid: z.string(),
  covered_message_count: z.number(),
  summary_tokens: z.number(),
  model: z.string(),
});

export type CompactionEvent = z.infer<typeof CompactionEventSchema>;
